import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import _ from "lodash";
import { Navigate, Route, Routes } from "react-router-dom";

import { DevicesSets } from "../../../../helpers/devices.helpers";
import { isSPSONAvailable } from "../../../../store/account";
import {
  ProfileNotRoamingDevicesTable,
  ProfileRoamingDevicesTable,
} from "../shared";
import { createDeviceLinkTab, TabList } from "../../../../components/tabList";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";
import { HorizontalScrollTabs } from "../../../../components/horizontalScrollTabs/HorizontalScrollTabs";
import { withSettingDevicesGuard } from "../../withSettingsDevicesGuard";

import "./NonDefaultProfileContent.scss";
import "../../../../components/devices/TableDevices.scss";

// LinkTab[]
const TABS = [
  { value: DevicesSets.NotRoaming, name: "all", url: "all" },
  { value: DevicesSets.Roaming, name: "roaming", url: "roaming" },
];

export const NonDefaultProfileContent = withSettingDevicesGuard(
  function NonDefaultProfileContent({ profile }) {
    const intl = useIntl();
    const showSPSON = useSelector(isSPSONAvailable);

    const tabs = useMemo(() => {
      const filteredTabs = showSPSON
        ? TABS
        : _.reject(TABS, {
            value: DevicesSets.Roaming,
          });

      // in case tabs array contains only one tab ("all") we aren't showing it
      if (filteredTabs.length === 1) {
        return [];
      }

      return filteredTabs.map((tab) => createDeviceLinkTab(tab, intl));
    }, [showSPSON, intl]);

    return (
      <section>
        <h2 className={"sr-only"}>
          <FormattedMessage id={"manage_devices"} />
        </h2>

        <section className={"devices__layout devices--per-profile"}>
          <div>
            <h2>
              <FormattedMessage id={"devices"} />
            </h2>
            <div className={"settings-page__description"}>
              {getDescription(profile)}
            </div>
          </div>
          <NotMobile>
            <TabList items={tabs} />
          </NotMobile>
          <Mobile>
            <HorizontalScrollTabs tabs={tabs} />
          </Mobile>
          <Routes>
            <Route
              path="all"
              element={
                <ProfileNotRoamingDevicesTable
                  profileName={profile.name}
                  profileId={profile.id}
                />
              }
            />

            {showSPSON && (
              <Route
                path="roaming"
                element={
                  <ProfileRoamingDevicesTable profileName={profile.name} />
                }
              />
            )}

            <Route path="*" element={<Navigate to="all" />} />
          </Routes>
        </section>
      </section>
    );
  }
);

const getDescription = (profile) => {
  const isEmployees = profile.type === "employees";
  const messageId = isEmployees
    ? "employees_full_description"
    : "custom_full_description";

  return <FormattedMessage id={messageId} />;
};
